import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import FormattersStore from '../stores/Formatters';
import PropTypes from 'prop-types';

const styles = {
  grid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  addOn: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginRight: 'xsmall',
    color: 'section',
    fontSize: 'small',
    gap: '3px'
  },
  addOnTitle: {
    textWrap: 'wrap',
    marginBottom: '0px'
  },
  addOnPrice: {
    textWrap: 'wrap',
    marginBottom: '0px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    minWidth: 'max-content'
  }
};

const AddonInfo = ({ selectedAddons }) => {
  const { numberFormatter } = FormattersStore.getState();
  const { Block } = UX2.Element;

  if (selectedAddons.length === 0) return null;

  return (
    <Block style={ styles.grid }>
      { selectedAddons?.map(addOn => {
        return (
          <Block key={ addOn.id } style={ styles.addOn }>
            <p style={ styles.addOnPrice }>{ numberFormatter.formatCurrency(+addOn.price) } |</p>
            <p style={ styles.addOnTitle }> { addOn.title }</p>
          </Block>
        );
      }) }
    </Block>
  );
};

AddonInfo.propTypes = {
  selectedAddons: PropTypes.array.isRequired
};

export default AddonInfo;
